<p-panel styleClass="panel-shadow" class="customer-windows" [style]="{ 'margin-top': '1em' }">
  <p-header>
    <div class="panel-header">Customer Windows</div>
  </p-header>

  <div [class.ghost]="loading || !task" class="mt-2">
    <ng-template
      #windowTemplate
      let-type="type"
      let-location="location"
      let-earliest="earliest"
      let-latest="latest"
    >
      <div class="mb-2" style="font-weight: 700; font-size: 14px">{{ type }}</div>

      <div class="mb-2 font-medium ghost-fill">
        <i class="fa fa-map-marker" style="color: #999"></i>
        <span class="ml-1">{{ formatAddress(location) }}</span>
      </div>

      <div class="mb-2 font-medium ghost-fill mt-2">
        <i class="fa fa-calendar" style="color: #999"></i>
        <span class="ml-1">{{ formatDateRange(earliest, latest) }}</span>
      </div>
    </ng-template>

    <div *ngIf="pickupLocation" class="mb-4">
      <ng-container
        *ngTemplateOutlet="
          windowTemplate;
          context: {
            type: 'Pick-up',
            location: pickupLocation,
            earliest: pickupEarliestDateTime,
            latest: pickupLatestDateTime
          }
        "
      >
      </ng-container>
    </div>

    <div *ngIf="dropoffLocation" class="mb-4">
      <ng-container
        *ngTemplateOutlet="
          windowTemplate;
          context: {
            type: 'Drop-off',
            location: dropoffLocation,
            earliest: dropoffEarliestDateTime,
            latest: dropoffLatestDateTime
          }
        "
      >
      </ng-container>
    </div>

    <div *ngIf="task">
      <small>
        These times are for emergencies. Please use the recommended times above, but these wider
        windows are provided as a backup in case of sudden changes to your route.
      </small>
    </div>
  </div>
</p-panel>
